mutation BulkAddComputedDeliverableMetadataValue(
    $libraryFilters: InputLibraryFilters!
    $fieldId: ID!
    $value: String!
) {
    addMetadataValue(libraryFilters: $libraryFilters, fieldId: $fieldId, value: $value) {
        __typename
        ... on Job {
            _id
            status
            message
        }
    }
}
